import log from 'loglevel';

// Set the default log level (e.g., 'info', 'warn', 'error', 'debug')
log.setLevel('info');

// Optionally, customize the log level dynamically based on the environment
if (process.env.NODE_ENV === 'development') {
  log.setLevel('debug');
} else if (process.env.NODE_ENV === 'production') {
  //log.setLevel('warn');
  log.setLevel('debug');
}

// Example of adding a custom prefix (optional)
const originalFactory = log.methodFactory;
log.methodFactory = (methodName, logLevel, loggerName) => {
  const rawMethod = originalFactory(methodName, logLevel, loggerName);
  return (...message) => {
    rawMethod(`[${new Date().toISOString()}] [${methodName.toUpperCase()}]:`, ...message);
  };
};
log.setLevel(log.getLevel()); // Apply the custom method factory

export default log;
